import {useI18n} from '@yandex-delivery/core/i18n'
import {Typography} from '@yandex-delivery/ui'
import React from 'react'

import {type LngLat, MapMarker} from '../../../map'
import styleClasses from './classes.module.css'

type Props = {
  address?: string
  coordinates: LngLat
}

export function AddressPin({address, coordinates}: Props) {
  const i18n = useI18n()

  return (
    <MapMarker coordinates={coordinates}>
      <div className={styleClasses.point}>
        <div className={styleClasses.labelWrapper}>
          <div className={styleClasses.label}>
            <Typography color="textMinor" density="tight" level="caption2" weight="regular">
              {i18n('tariffs-v3.map.address-pin.title', 'Ваш адрес')}
            </Typography>

            <Typography density="normal" level="caption1" weight="regular">
              {address}
            </Typography>

            <LabelTail />
          </div>
        </div>
      </div>
    </MapMarker>
  )
}

function LabelTail() {
  return (
    <svg className={styleClasses.tail} viewBox="52 0 24 8" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M64 8L63.5777 7.15542C63.3258 6.65156 63.1998 6.39963 63.0728 6.17114C61.0469 2.52532 57.2731 0.193012 53.1062 0.0113831C52.845 0 52.5633 0 52 0L76 0C75.4367 0 75.155 0 74.8938 0.0113831C70.7269 0.193012 66.9531 2.52532 64.9272 6.17114C64.8002 6.39962 64.6742 6.65154 64.4223 7.15536L64.4223 7.15542L64 8Z"
        fill="white"
      />
    </svg>
  )
}
